module.exports = __webpack_public_path__ + "static/img/bg-pt.c4e18a67.png";